import Scrollbar from "smooth-scrollbar";
import DisableScrollbarPlugin from "./disable-scrollbar-plugin";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { ParallaxController } from "parallax-controller";

gsap.registerPlugin(ScrollTrigger);

class CustomScrollbar {
	constructor(element, options) {
		this.scrollbarInstance = null;
		this.element = element;
		this.options = options;
		this.gsap = gsap;
		this.ScrollTrigger = ScrollTrigger;
		this.parallaxController = null;
		this.init();
	}

	init() {
		Scrollbar.detachStyle();
		Scrollbar.use(DisableScrollbarPlugin);
		this.scrollbarInstance = Scrollbar.init(this.element, this.options);

		this.ScrollTrigger?.scrollerProxy(this.element, {
			scrollTop: (value) => {
				if (arguments.length && value) {
					this.scrollbarInstance.scrollTop = value;
				}
				return this.scrollbarInstance.scrollTop;
			},
		});

		this.parallaxController = ParallaxController.init({
			scrollContainer: this.element,
		});

		this.scrollbarInstance.addListener(() => {
			this.ScrollTrigger?.update();
			this.parallaxController?.update();
		});

		this.ScrollTrigger?.defaults({
			scroller: this.element,
			// markers: theme_frontend_scripts_params.enviroment === "DEVELOPMENT",
		});

		window.addEventListener("load", () => {
			this.updateAll();

			window.addEventListener(
				"change-page",
				() => {
					// console.log("CUSTOM SCROLLBAR CHANGE PAGE");
					this.updateAll();
				},
				true,
			);
		});

		window.addEventListener("resize", () => {
			this.updateAll();
		});
	}

	updateAll() {
		this.scrollbarInstance?.update();
		this.ScrollTrigger?.refresh();
		this.parallaxController?.update();
	}

	markersUpdate = () => {
		if (document.querySelector(".gsap-marker-scroller-start")) {
			const markers = this.gsap.utils.toArray(
				'div[class^="gsap-marker"], div[class*="gsap-marker"]',
			);
			if (markers.length > 0) {
				this.scrollbarInstance.addListener(({ offset }) => {
					this.gsap.set(markers, { marginTop: -offset.y });
				});
			}
		}
	};
}

export default CustomScrollbar;
